import { getLuminance } from 'color2k';
import { roundToTwo } from './general';

/**
 * Get the background color of the element
 * @param elem HTML Element
 * @returns
 */
export function getRealBackgroundColor(elem: HTMLElement | null): string {
  const transparent = 'rgba(0, 0, 0, 0)';
  if (!elem) return transparent;

  const computed = getComputedStyle(elem);
  if (computed.backgroundImage !== 'none') {
    return '';
  }

  const bg = computed.backgroundColor;
  if (bg === transparent) {
    return getRealBackgroundColor(elem.parentElement);
  } else {
    return bg;
  }
}

/**
 * Create an RGB color from RGBA
 * @param rgba The rgba string like rgba(0, 0, 0, 0)
 * @returns RGB color like rgb(255, 255, 255)
 */
function getRGBColorFromRGBA(rgba: string) {
  const parseRgba = rgba.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
  if (parseRgba) {
    const [, red, green, blue, alpha] = parseRgba;
    const adjustedAlpha = 1 - Number(alpha);
    const adjustedRed = Math.min(Math.round(Number(red) + adjustedAlpha * 255), 255);
    const adjustedGreen = Math.min(Math.round(Number(green) + adjustedAlpha * 255), 255);
    const adjustedBlue = Math.min(Math.round(Number(blue) + adjustedAlpha * 255), 255);
    return `rgb(${adjustedRed}, ${adjustedGreen}, ${adjustedBlue})`;
  } else {
    return rgba;
  }
}
/**
 * Get background color luminance rating of an HTML element
 * @param elem HTML element to get the background color of
 * @returns background color luminance rating
 */
export function getColorLuminance(elem: HTMLElement | null): number {
  if (!elem) {
    return 1;
  }
  const wrapperParent = elem.parentElement;
  let backgroundColor = getRealBackgroundColor(wrapperParent);
  if (backgroundColor.includes('rgba')) {
    backgroundColor = getRGBColorFromRGBA(backgroundColor);
  }
  let luminance;
  try {
    luminance = roundToTwo(getLuminance(backgroundColor));
  } catch (_e) {
    luminance = 1;
  }
  return luminance;
}
